module.exports = __webpack_public_path__ + "static/media/background.56139d7f.png";